import { site } from "./site";

export const socials = [
  {
    label: "Instagram",
    href: site.instagram,
    note: "Existing public social link from the current website."
  }
];
